import { injectable } from 'inversify';
import { AxiosRequestConfig, AxiosPromise } from 'axios';
import { HttpServiceBase } from './HttpServiceBase';
import { ODataResponse } from '@/models';

@injectable()
export abstract class EntityServiceBase<T> extends HttpServiceBase {
  private baseUrl: string = "";
  private oDataBaseUrl: string = "";
  private entityName: string = "";

  public get BaseUrl(): string {
    return this.baseUrl;
  }

  public get ODataBaseUrl(): string {
    return this.oDataBaseUrl;
  }

  public get EntityName(): string {
    return this.entityName;
  }

  public set EntityName(entityName: string) {
    this.entityName = entityName;
    this.baseUrl = `api/${this.entityName}`;
    this.oDataBaseUrl = `odata/OData${this.entityName}`;
  }

  public GetRecord<T>(url: string, config?: AxiosRequestConfig): AxiosPromise<T> {
    return this.Get<T>(`${this.baseUrl}${url}`, config);
  }

  public GetRecords<T>(url: string, config?: AxiosRequestConfig): AxiosPromise<T> {
    return this.Get<T>(`${this.baseUrl}${url}`, config);
  }

  public Create(record: T): AxiosPromise<T> {
    return this.Post<T>(this.baseUrl, JSON.stringify(record), {
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
    });
  }

  public Update(record: T): AxiosPromise<T> {
    return this.Patch<T>(this.baseUrl, JSON.stringify(record), {
      headers: { 'Content-Type': 'application/json; charset=utf-8' },
    });
  }

  public Remove(id: string): AxiosPromise<T> {
    return this.Delete<T>(`${this.baseUrl}/${id}`);
  }

  public ODataQuery<T>(url: string): Promise<ODataResponse<T>> {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await this.Get<any>(`${this.oDataBaseUrl}${url}`);
        resolve(new ODataResponse<T>(response.data));
      } catch (error) {
        reject(error);
      }
    });
  }
}